import { observer } from "mobx-react-lite";
import { FC } from "react";
import styled from "@emotion/styled";
import { RenameFileModalStore } from "@/components/modal/rename-file/rename-file-modal-store";
import {
  MDSButton,
  MDSButtonGroup,
  MDSButtonVariant,
  MDSDialogSlotName,
  MDSModalDialog,
  MDSText,
  MDSTextField,
  MDSTextVariant,
} from "@/mds";

export interface RenameFileModalProps {
  store: RenameFileModalStore;
}

export const RenameFileModal: FC<RenameFileModalProps> = observer(({ store }) => {
  return (
    <StyledRenameFileDialog isOpen={store.isOpen} handleClose={() => store.close()}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        Rename file
      </MDSText>
      <div slot={MDSDialogSlotName.Content}>
        <MDSTextField
          value={store.inputValue}
          onChange={value => store.setInputValue(value)}
          inputProps={{
            onKeyDown: e => {
              if (e.key === "Enter") {
                e.preventDefault();
                store.submit();
              }
            },
          }}
          autoFocus
        />
      </div>
      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton onClick={() => store.close()}>Cancel</MDSButton>
        <MDSButton
          variant={MDSButtonVariant.Contrast}
          isDisabled={store.isSubmitDisabled}
          onClick={() => store.submit()}
        >
          Update
        </MDSButton>
      </MDSButtonGroup>
    </StyledRenameFileDialog>
  );
});

const StyledRenameFileDialog = styled(MDSModalDialog)`
  .mds-dialog {
    padding: ${({ theme }) => theme.spacing[7]};
  }
`;
